import api from "../services/api";


export const fetchProtectionTiers = async () => {
  try {
    const response = await api.get("/protection-tier-management/protection/tiers");

    if (response.status === 200 && response.data.success) {
      return { success: true, data: response.data.data };
    } else {
      return {
        success: false,
        error: response.data?.message || "Unexpected server response",
      };
    }
  } catch (error) {
    return {
      success: false,
      error:
        error.response?.data?.detail ||
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch protection tiers",
    };
  }
};

export const createProtectionTier = async ({ min_value, max_value, rate }) => {
  try {
    const response = await api.post(
      "/protection-tier-management/protection/tiers/create",
      { min_value, max_value, rate }
    );

    if (response.status === 200 && response.data.success) {
      return { success: true, data: response.data.data };
    } else {
      return {
        success: false,
        error: response.data?.message || "Unexpected server response",
      };
    }
  } catch (error) {
    return {
      success: false,
      error:
        error.response?.data?.detail ||
        error.response?.data?.message ||
        error.message ||
        "Failed to create protection tier",
    };
  }
};


export const updateProtectionTier = async (tierId, updates) => {
  try {
    const response = await api.put(
      `/protection-tier-management/protection/tiers/${tierId}`,
      updates
    );

    if (response.status === 200 && response.data.success) {
      return { success: true, data: response.data.data };
    } else {
      return {
        success: false,
        error: response.data?.message || "Unexpected server response",
      };
    }
  } catch (error) {
    return {
      success: false,
      error:
        error.response?.data?.detail ||
        error.response?.data?.message ||
        error.message ||
        "Failed to update protection tier",
    };
  }
};


export const deleteProtectionTier = async (tierId) => {
  try {
    const response = await api.delete(
      `/protection-tier-management/protection/tiers/${tierId}`
    );

    if (response.status === 200 && response.data.success) {
      return { success: true, message: response.data?.message || "Deleted successfully" };
    } else {
      return {
        success: false,
        error: response.data?.message || "Unexpected server response",
      };
    }
  } catch (error) {
    return {
      success: false,
      error:
        error.response?.data?.detail ||
        error.response?.data?.message ||
        error.message ||
        "Failed to delete protection tier",
    };
  }
};